var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dialog-background"},[_c('v-dialog',{attrs:{"value":true,"persistent":"","overlay-opacity":0.95,"overlay-color":"white","max-width":"700"}},[_c('CompanyBillingInfo')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }